import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../http.service';
import * as Constants from '@emi/shared/constants';
import { ScorecardDto } from 'libs/sku-capsule/feature/sku-summary/src/lib/models';

@Injectable({
    providedIn: 'root'
})
export class SkuScorecardService {

    constructor(private httpService: HttpService) { }

    public getSkuScorecard(emiItemId: number, startDate: Date, endDate: Date): Observable<ScorecardDto> {
        return this.httpService.getHttp<ScorecardDto>(
            `${Constants.ServiceConstants.SKUS}/${emiItemId}/scorecard`,
            {
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString()
            }
        );
    }
}
